/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ManualEmailStepPriority = typeof ManualEmailStepPriority[keyof typeof ManualEmailStepPriority];


export const ManualEmailStepPriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
